import { UnwrapNestedRefs } from 'vue';
import TenantEndpoint from '@/app/auth/endpoints/TenantEndpoint';
import Tenant from '@/app/auth/models/Tenant';
import { Mode } from '@/app/enums/tenant/Mode';
import EndpointFactory from '@/app/factories/EndpointFactory';
import { ModelType } from '@/app/base/schemas/BaseSchema';

const useTenantModeSwitch = () => {
    const isLoading = ref(false);
    // `redirectTo` avoids bouncing the user back to the dashboard when the switch was triggered
    // from a flow that has a next step (e.g. activating e-invoicing from the FR announcement panel).
    const switchMode = async ({ tenant, mode, redirectTo }: { tenant: UnwrapNestedRefs<Tenant>; mode: Mode; redirectTo?: string }) => {
        isLoading.value = true;
        const endpoint = EndpointFactory.make(ModelType.TENANTS) as TenantEndpoint;
        const { data } = await endpoint.mode(tenant.getId(), mode);

        // The switch used to leave the button spinning forever on failure, with no feedback.
        if (!data) {
            isLoading.value = false;
            useToasteoError();
            return;
        }

        window.location.replace(redirectTo ?? '/');
    };

    return { isLoading, switchMode };
};

export default useTenantModeSwitch;
